<div class="refer-friend-wrapper">
  <div class="title">{{'Stories.referAFriend.referAFriend' | translatePipe | async}}</div>
  <div class="divider"></div>
  <div class="desc">
    {{'Stories.referAFriend.contactDesc1' | translatePipe | async}}
  </div>
  <button class="refer-btn" mat-raised-button (click)="openPopup(referRef)">{{'Stories.referAFriend.referAFriendBtn' | translatePipe | async}}</button>
</div>


<ng-template #referRef>
  <div class="refer-wrapper">
    <div *ngIf="!isSubmited" class="header">
      <img loading="lazy" data-src="/assets/images/small-logo.png"/>
      <div class="title">REFER A FRIEND</div>
      <div class="subtitle">
        In need of funds for medical treatment or know someone who might be?
      </div>
    </div>
    <app-common-talktous-modal class="action-btns" [header]="false"
                              leadQueryType="want_to_raise_funds" frCause="medical" [askQuery]="false"
                              [hideFields]="{typeOfQuery: true, cause: true}" (isFormSubmit)="isSubmited = $event">
    </app-common-talktous-modal>
  </div>
</ng-template>
